'use strict';

var _ = require('lodash');
var repeaterUtils = require('../../repeaterUtils/repeaterUtils');
var modelUtils = require('../../modelUtils');

function cloneConnections(model, templateCompIds, itemIds) {
  var connections = _.get(model, 'connections');
  var contexts = _.keys(connections);
  _.forEach(contexts, function (context) {

    var roles = _.keys(_.get(connections, context));
    _.forEach(roles, function (role) {

      var compIds = _.keys(_.get(connections, [context, role]));
      _.forEach(compIds, function (compId) {
        if (_.includes(templateCompIds, compId)) {
          var templateConfig = _.get(connections, [context, role, compId]);

          _.forEach(itemIds, function (itemId) {
            var displayedItemId = repeaterUtils.structure.getUniqueDisplayedId(compId, itemId);
            _.set(connections, [context, role, displayedItemId], _.cloneDeep(templateConfig));
          });
        }
      });
    });
  });
}

function updateCompsScope(model, templateCompIds, itemIds) {
  _.forEach(templateCompIds, function (templateCompId) {
    _.forEach(itemIds, function (itemId) {
      var displayedItemId = repeaterUtils.structure.getUniqueDisplayedId(templateCompId, itemId);
      model['componentsScopes'][displayedItemId] = null;
    });
  });
}

function cloneComponents(model, templateCompIds, itemIds, repeaterId) {
  _.forEach(templateCompIds, function (templateCompId) {
    _.forEach(itemIds, function (itemId) {
      var newDisplayedCompId = repeaterUtils.structure.getUniqueDisplayedId(templateCompId, itemId);
      var templateData = model.components[templateCompId];
      var newDisplayedCompData = _.cloneDeep(templateData);
      newDisplayedCompData.displayedOnlyComponents = [];
      newDisplayedCompData.children = _.map(templateData.children, function (childId) {
        return repeaterUtils.structure.getUniqueDisplayedId(childId, itemId);
      });
      newDisplayedCompData.parent = templateData.parent === repeaterId ? repeaterId : repeaterUtils.structure.getUniqueDisplayedId(templateData.parent, itemId);
      newDisplayedCompData.displayedRoot = repeaterId;
      newDisplayedCompData.isDisplayed = !!_.get(model.components[repeaterId], 'isDisplayed');
      /*change data-item id for refs*/
      _.forEach(repeaterUtils.structure.SPLITTED_DATA_TYPES, function (dataType) {
        var compDataTypeValue = newDisplayedCompData[dataType];
        if (compDataTypeValue.id) {
          compDataTypeValue.id = repeaterUtils.structure.getUniqueDisplayedId(newDisplayedCompData[dataType].id, itemId);
          _.forEach(compDataTypeValue, function (val, key) {
            if (_.isObject(val) && val.id) {
              compDataTypeValue[key].id = repeaterUtils.structure.getUniqueDisplayedId(compDataTypeValue[key].id, itemId);
            }
          });
        }
      });

      model.components[newDisplayedCompId] = newDisplayedCompData;
    });
  });
}

function cloneComponentsAndConnections(model, templateCompIds, itemIds, repeaterId) {
  cloneConnections(model, templateCompIds, itemIds);
  cloneComponents(model, templateCompIds, itemIds, repeaterId);
  updateCompsScope(model, templateCompIds, itemIds);
}

function removeConnections(model, templateCompIds, itemIds) {
  var connections = _.get(model, 'connections');
  var contexts = _.keys(connections);

  _.forEach(contexts, function (context) {
    var roles = _.keys(_.get(connections, [context]));

    _.forEach(roles, function (role) {
      var compIds = _.keys(_.get(connections, [context, role]));

      _.forEach(compIds, function (compId) {
        var compItemId = repeaterUtils.structure.getItemId(compId);
        var compOriginalId = repeaterUtils.structure.getOriginalId(compId);

        if (compItemId && _.includes(itemIds, compItemId) && _.includes(templateCompIds, compOriginalId)) {
          delete connections[context][role][compId];
        }
      });
    });
  });
}

function removeCompsScope(model, templateCompIds, itemIds) {
  _.forEach(templateCompIds, function (templateCompId) {
    _.forEach(itemIds, function (itemId) {
      var displayedItemId = repeaterUtils.structure.getUniqueDisplayedId(templateCompId, itemId);
      delete model.componentsScopes[displayedItemId];
    });
  });
}

function removeComponents(model, templateCompIds, itemIds) {
  _.forEach(templateCompIds, function (templateCompId) {
    _.forEach(itemIds, function (itemId) {
      var displayedItemId = repeaterUtils.structure.getUniqueDisplayedId(templateCompId, itemId);
      delete model.components[displayedItemId];
    });
  });
}

function removeComponentsAndConnections(model, templateCompIds, itemIds) {
  removeConnections(model, templateCompIds, itemIds);
  removeCompsScope(model, templateCompIds, itemIds);
  removeComponents(model, templateCompIds, itemIds);
}

/*on repeater set items - creates displayed components and connections for added items and removes components and connections that are no loger in items*/
function updateRepeaterItems(RMI, hookName, repeaterId, partial) {
  if (partial.items) {
    var templateCompIds = modelUtils.getAllCompsUnderRoot(RMI._model, repeaterId);
    var repeaterData = _.get(RMI._model.components, [repeaterId, 'data']);
    var addedItems = repeaterUtils.items.getAddedItems(repeaterData.items, partial.items);
    cloneComponentsAndConnections(RMI._model, templateCompIds, _.map(addedItems, 'item._id'), repeaterId);

    var removedItems = repeaterUtils.items.getRemovedItems(repeaterData.items, partial.items);
    removeComponentsAndConnections(RMI._model, templateCompIds, _.map(removedItems, 'item._id'));
    _.forEach(templateCompIds, function (templateCompId) {
      var templateCompData = RMI._model.components[templateCompId];
      templateCompData.displayedOnlyComponents = _.map(partial.items, function (itemId) {
        return repeaterUtils.structure.getUniqueDisplayedId(templateCompId, itemId);
      });
    });
  }
}

/*Hook triggered on each set and check if the set is for template sync all existing item instances*/
function syncRepeaterItemData(RMI, hookName, compId) {
  var _arguments = arguments;

  var model = RMI._model;
  // set comp property to the template comp, since its isDisplayed property is always false
  if (hookName !== 'registerEvent' && modelUtils.isTemplateComp(model, compId)) {
    var comp = _.get(model, ['components', compId]);
    var partial = arguments[3];
    model.components[compId][hookName] = _.defaults({}, partial, comp[hookName]);
  }

  var displayedOnlyComponents = _.get(RMI._model.components, [compId, 'displayedOnlyComponents']);
  if (!_.isEmpty(displayedOnlyComponents)) {
    //is repeater template with displayed only comps
    var funcName = 'set' + _.startCase(hookName);
    if (hookName === 'registerEvent') {
      funcName = 'registerEvent';
      _.forEach(displayedOnlyComponents, function (itemId) {
        var args = [].concat(Array.prototype.slice.call(_arguments));
        RMI[funcName].apply(RMI, [args[3], itemId].concat(args.splice(4)));
      });
      return;
    }
    _.forEach(displayedOnlyComponents, function (itemId) {
      var args = [].concat(Array.prototype.slice.call(_arguments));
      if (hookName === 'data' && !_.isFunction(_.last(args))) {
        //if there is no callback should call setDataWithoutUpdate and not setData
        RMI.setDataWithoutUpdate.apply(RMI, [itemId].concat(args.splice(3)));
        return;
      }
      RMI[funcName].apply(RMI, [itemId].concat(args.splice(3)));
    });
  }
}

module.exports = {
  updateRepeaterItems: updateRepeaterItems,
  syncRepeaterItemData: syncRepeaterItemData
};


// WEBPACK FOOTER //
// ./~/santa-platform-utils/lib/RMIHooks/hooks/repeaterHooks.js